import { InspectionStatus } from "src/data/types";

export type LOADING_STATE = "idle" | "pending" | "fulfilled" | "rejected";

export const DEFAULT_LOCALE = "en";
export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "homepage";

// LDAP Groups for WHSEAP
export const WHS_DATA_EAP_USER_LDAP_GROUP = "whs-data-eap-user";
export const WHS_DATA_EAP_ADMIN_LDAP_GROUP = "whs-data-eap-admin";
export const WORKINGWELL_ENGINEER_LDAP_GROUP = "workingwell-engineer";

// All valid LDAP groups
export const VALID_LDAP_GROUPS = [
  WHS_DATA_EAP_USER_LDAP_GROUP,
  WHS_DATA_EAP_ADMIN_LDAP_GROUP,
  WORKINGWELL_ENGINEER_LDAP_GROUP,
];

// Check if user is admin (has admin or engineer permissions)
export const isAdminUser = (ldapGroups: string[]): boolean => {
  return ldapGroups.some(
    (group) =>
      group === WHS_DATA_EAP_ADMIN_LDAP_GROUP ||
      group === WORKINGWELL_ENGINEER_LDAP_GROUP
  );
};

// Check if user has any valid permissions
export const hasValidPermissions = (ldapGroups: string[]): boolean => {
  return ldapGroups.some((group) => VALID_LDAP_GROUPS.includes(group));
};

// Check if user is an engineer (has dev mode access)
export const isEngineerUser = (ldapGroups: string[]): boolean => {
  return ldapGroups.some((group) => group === WORKINGWELL_ENGINEER_LDAP_GROUP);
};

export const INSPECTION_TABLE_HEADERS = [
  "Inspection",
  "Type",
  "Location",
  "Frequency",
  "Mandate",
  "Status",
];
export const ADD_DETAILS = "add-details";
export const ADD_QUESTIONS = "add-questions";
export const AI = "AI";
export const MANUAL_OVERRIDE = "Manual Override";
export const NON_COMPLIANT = "non_compliant";
export const COMPLIANT = "compliant";
export const compliantStatus = {
  YES: "Yes",
  NO: "No",
};
export const inProgressInspectionStatus = "In_Progress";
export const completedInspectionStatus = "Completed";
